<template>
    <div>
        <!--提示标题栏-->
        <div style="width: 88%;height: 40px;line-height:40px;">
            <div style="
            background-color: #adadad;
            width: 150px;
            height: 40px;
            text-align: center;
            vertical-align: middle;
            float: left;">
              满减活动配置
            </div>
            <div style="
            background-color: #adadad;
            margin-left: 2px;
            width: 35%;
            height: 40px;
            text-align: center;
            color: #adadad;
            float: left;">
                满减活动配置
            </div>
        </div>
        <!--查询当前已经配置的每日特价-->
        <div>



            <br>
            <!--  ===================================================form 表单区域=====================================================-->
                <el-form :model="appInfo" :rules="rules" ref="appInfo" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="满" prop="coupon_num_x">

                            <el-input-number v-model="appInfo.coupon_num_x"  :min="0.01" :max="10000"  placeholder=" 0.01-10000"label="满X元" ></el-input-number>




                    </el-form-item>
                    <el-form-item label=" "  >&nbsp;</el-form-item>
                    <el-form-item label="减"  prop="coupon_num_y" >

                        <el-input-number v-model="appInfo.coupon_num_y"  :min="0.01" :max="10000"  placeholder=" 0.01-10000" label="减Y元"></el-input-number>
                    </el-form-item>


                    <el-form-item label=" "  >&nbsp;</el-form-item>
                    <el-form-item label="规则描述">
                       <el-input v-model="appInfo.rule_desc"   type="textarea"></el-input>
                      <!--  <textarea v-model="appInfo.rule_desc"  ></textarea>-->
                    </el-form-item>
                    <el-form-item label=" "  >&nbsp;</el-form-item>
                    <el-form-item label="使用说明">
                        <el-input v-model="appInfo.rule_use_desc" type="textarea"   ></el-input>
                        <!--<textarea v-model="appInfo.rule_use_desc"  ></textarea>-->
                    </el-form-item>
                    <el-form-item label="选择" >
                        <el-col :span="3">
                            <el-radio v-model="appInfo.goods_type" label ="0" @change="getGoodsStr">所有商品参加</el-radio>
                        </el-col>
                        <el-col :span="3">
                            <el-radio v-model="appInfo.goods_type" label ="1" @change="getGoodsStr">部分商品参加</el-radio>
                        </el-col>
                       <!-- <el-col :span="2">&nbsp;</el-col>-->
                        <el-col :span="3">
                        <el-button   v-if="appInfo.goods_type==1" type="primary" class="" @click="showProduct()"   >获取商品</el-button>
                    </el-col>
                      <!--  <el-col :span="3">
                            <el-button   type="primary" class="" @click="is_show_portion_product_list=true"   >查看已选商品</el-button>
                        </el-col>-->
                        <el-col :span="2">

                            <el-button   v-if="is_show_portion_product_list" :disabled="batchdisable" type="primary" class="" @click="batchRemoveGoods()"   >删除已选商品</el-button>
                          <!--  <el-button   v-if="appInfo.goods_type==1" type="primary" class="" @click="showProduct()"   >获取商品</el-button>-->
                        </el-col>
                    </el-form-item>

                  <!--  <el-button type="primary" class=""  @click="submitForm('appInfo')" >保存</el-button>-->


                </el-form>
            <!--  ===================================================已选择的商品展示区域=====================================================-->
            <el-table v-if="is_show_portion_product_list" ref="multipleTable"  :data="readGoodslist" tooltip-effect="dark"
                      style="width: 100%"
                      @selection-change="batchGetGoods">
              <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column align="center" prop="Image" label="商品图片">
                    <template slot-scope="scope">
                        <img :src="scope.row.Image" class="avatar" style="height: 50px;">
                    </template>
                </el-table-column>
                <el-table-column prop="productName" label="商品名称"></el-table-column>
                <el-table-column prop="price" label="商品价格"></el-table-column>
                <el-table-column prop="machine_id" label="机器编号"></el-table-column>

                <el-table-column prop="price" label="线上价格">

                </el-table-column>
                <el-table-column  label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.price!=''&& scope.row.SKU!='' " style="color:green">上架</span>
                        <span v-if="scope.row.price==''&& scope.row.SKU!='' " style="color:red">下架</span>
                        <span v-if="scope.row.price==''&& scope.row.SKU=='' " style="color:red">已删除</span>
                    </template>
                </el-table-column>
                <!--<el-table-column label="操作">
                   <template slot-scope="scope">
                       <el-button type="primary"  @click="removeGoods(scope.row.id)" >移除</el-button>
                   </template>
                </el-table-column>-->

            </el-table>

            <div class="block" v-if="is_show_portion_product_list">

                <el-pagination
                        @current-change="handleCurrentChange"
                        @size-chahange="handleSizeChange"
                        :current-page="currentpage"
                        :page-count="pagesCount"
                        :page-sizes="pagesizes"
                        :page-size="pagesize"
                        :total="pagesCount"
                        layout=" total, prev, pager, next, jumper"
                >
                </el-pagination>
            </div>

            <!-- 商品组件-->
            <br>
            <el-dialog
                    title="商品"
                    :visible.sync="dialogVisible"
                    :modal-append-to-body="false"
                    width="70%" top="30%"
                   >
                <ProductPutWay v-if="isShowProduct" @handle-selection-change="handleSelectionChange" :kioskNoList="kioskNoList" @close-product="closeProduct" :is_checkbox="is_checkbox"></ProductPutWay>
            </el-dialog>
            <el-form-item  style="margin-left: 16.5%" >
              <el-button type="primary" @click="lastStep()"
                           id="last_step" >上一步
                </el-button>
                <el-button type="primary" @click="submitForm('appInfo')"
                           id="next_step" >保存修改
                </el-button>

                <el-button  v-if="act_status==-1" type="primary" class="" @click="startOrPaseAct('1')" >提交</el-button>
            </el-form-item>

        </div>
    </div>
</template>

<script>
    import ProductPutWay from "~/components/views/activity/ProductPutaWay.vue";
    import ElForm from "../../../../node_modules/element-ui/packages/form/src/form.vue";
    import ElFormItem from "../../../../node_modules/element-ui/packages/form/src/form-item.vue";
    import ElInput from "../../../../node_modules/element-ui/packages/input/src/input.vue";
    import ElCol from "element-ui/packages/col/src/col";
    export default {
        name: "SeckillApp",
        components: {
            ElCol,
            ElInput,
            ElFormItem,
            ElForm,
            ProductPutWay
        },
        props:
            ['actId' ],
        data() {
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 3,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                pushData: [], // 分页组件传回的分页后数据

              //actId:"act1554775508625754578",
                kioskNoList:[],
                isShowProduct:false,
                is_checkbox:true,
                readGoodslist:[],
                //dialog value
                dialogVisible:false,
                modal:false,
                is_show_portion_product_list:false,
                batchdisable:true,
                act_status:-1,
                status_btn:0,
                appInfo:{
                    discounts_id:"1001",
                    rule_type_id:"1002",
                    ruleId:"",
                    appId:"",
                    coupon_num_x:"",
                    coupon_num_y:"",
                    rule_name:"",
                    rule_desc:"",
                    goods_type:'1',
                    rule_use_desc:"",
                    sku_str:"",
                    ids:""
                },

                rules: {
                    coupon_num_x:[
                        { required: true, message: '金额不能为空', type: 'number',trigger: 'blur'},
                    ],
                    coupon_num_y: [
                        { required: true, message: '金额不能为空', type: 'number',trigger: 'blur'},
                    ],

                }
            }
        },
        created(){
            this.findkioskNoList();
            this.findFullSubractList();
            this.status_btn=this.$route.query.btnStatus;
            this.act_status=this.$route.query.act_status;
        },
        methods: {
            //======================================分页
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pagesize = val
                this.activeNum = (val * this.currentpage) - val;
                this.endNum = (val * this.currentpage)
                this.findFullSubractList();
                //数目变更
            },
            handleCurrentChange(val) {
                this.currentpage = val;

                this.activeNum = (this.pagesize * val) - this.pagesize
                this.endNum = (this.pagesize * val)
                this.findFullSubractList();
            },
           //=====================================================查询=====================================================
           //设备列表
            findkioskNoList:function(){
                var url=this.admin_host+"/admin/activity/machine/find/list"
                this.$http.get(url+"?actId="+this.actId+"&iDisplayStart=0&iDisplayLength=50&tenantId="+this.getcookie('storeId'))
                    .then(response => {
                        this.kioskNoList=response.body.Data.machineList;
                        console.log(this.kioskNoList);
                    })
            },

            // 满减活动信息
            findFullSubractList:function(){
             // this.admin_host="http://localhost:8765/vueFeign";
                var url=this.admin_host+"/admin/activity/app/fullminus/find/info"
                this.$http.get(url+"?actId="+this.actId+"&iDisplayStart="+ this.activeNum+"&iDisplayLength="+this.pagesize+"")
                    .then(response => {
                        if (response.body.Code === "200") {
                           // 缓存商品信息
                            this.readGoodslist=response.body.Data.goodslist;
                            this.pagesCount=response.body.Data.goodsCount
                            // 生成商品str
                            this.appInfo.sku_str="";

                            if(this.readGoodslist.length>0){
                                for(var i=0;i<this.readGoodslist.length;i++){
                                    var sku=this.readGoodslist[i].goods_id;
                                    var machineId=this.readGoodslist[i].machine_id;
                                    var str=machineId+"="+sku;
                                    this.appInfo.sku_str+=str+",";
                                }
                            }
                            // 缓存满减活动信息
                            var rule=response.body.Data.ruleInfo;
                            if(rule!=null){
                                this.appInfo.discounts_id=rule.discounts_id;
                                this.appInfo.rule_type_id=rule.rule_type_id;
                                this.appInfo.ruleId=rule.ruleId;
                                this.appInfo.appId=response.body.Data.appId;
                                this.appInfo.coupon_num_x=rule.coupon_num_x;
                                this.appInfo.coupon_num_y=rule.coupon_num_y;
                                this.appInfo.rule_name=rule.rule_name;
                                this.appInfo.rule_desc=rule.rule_desc;

                                this.appInfo.goods_type=response.body.Data.goodsType+"";
                                this.appInfo.rule_use_desc=rule.rule_use_desc;
                                //如果类型为部分则显示部分商品列表
                                if(response.body.Data.goodsType==1){
                                    this.is_show_portion_product_list=true;
                                }
                            }

                        }else   {this.$message({showClose: true, message: '操作异常', type: 'error' }); }
                    },function(response){ this.$message({ showClose: true, message: '网络异常',type: 'error'}); })
            },
           //根据设备查询商品  如果选择所有商品，需要生成商品
            getPutaWay:function (params) {
                var _this=this;
                _this.$http.post(_this.productURL + "/vueFeign/getProductPutaway", params).then(response => {
                    if (response.status === 200) {
                        var this_=_this;
                        if (response.body.Code == '200') {
                            var d=response.body.Data.data;
                            if(d.length>0){
                                $.each(d,function(i,item){
                                    var sku= item.SKU;
                                    var machine_id=item.kioskNo;
                                    var str=machine_id+"="+sku;
                                    this_.appInfo.sku_str+=str+=",";
                                })
                            }

                        } else if (response.body.code == '500') {
                            _this.$message({showClose: true, message: response.body.msg, type: 'error'});
                        }
                    }

                }, function (response) { _this.$message({ showClose: true,message: '查询商品网络异常',type: 'error' });  });


            },
           //==================================================================新增、修改、删除============================================================
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.appInfo.sku_str==""){
                            this.$message({showClose: true,message: '请选择商品', type: 'error' });
                        }else{
                            this.saveAjax();
                        }

                    } else {
                        //  console.log('error submit!!');
                        return false;
                    }
                });
            },

           //新增满减活动
            saveAjax:function(){
                var params = {
                    actId:this.actId,
                    coupon_num_x:this.appInfo.coupon_num_x,
                    coupon_num_y:this.appInfo.coupon_num_y,
                    discounts_id:this.appInfo.discounts_id,
                    rule_type_id:this.appInfo.rule_type_id,
                    goods_type:this.appInfo.goods_type,
                    sku_str:this.appInfo.sku_str,
                    rule_use_desc:this.appInfo.rule_use_desc,
                    rule_desc:this.appInfo.rule_desc,
                    appId:this.appInfo.appId,
                    ruleId:this.appInfo.ruleId,
                };
                console.log(params);
               // this.admin_host="http://localhost:8780/marketing";
                var url=""

                if(this.appInfo.appId==""){

                    url=this.admin_host+"/admin/activity/app/fullminus/save";
                }else{

                    url=this.admin_host+"/admin/activity/app/fullminus/modify";
                }
                //异步请求
                this.$http.post(url,params)
                    .then(response => {
                        if (response.body.Code === "200") {
                            console.log(response.body)
                            /*if(this.appInfo.appId==""){
                                this.startOrPaseAct(1);
                            }*/



                            this.$message({
                                showClose: true,
                                message: '操作成功',
                                type: 'success'
                            });

                            this.findFullSubractList();
                        }else   {
                            this.$message({
                                showClose: true,
                                message: '操作异常',
                                type: 'error'
                            });
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })
                    },
            // 删除参与满减商品
            removeGoods:function(ids){
                var url=this.admin_host+"/admin/activity/app/fullminus/delete/goods";
                var params={id:ids}
                this.$http.post(url,params)
                    .then(response => {
                        if (response.body.Code === "200") {

                            this.findFullSubractList();
                            this.$message({
                                showClose: true,
                                message: '操作成功',
                                type: 'success'
                            });

                        }else   {
                            this.$message({
                                showClose: true,
                                message: '操作异常',
                                type: 'error'
                            });
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })
            },
            //修改活动状态
            startOrPaseAct(status){
                //数据请求
                this.loading = true
                var params = {actStatus:status,actId:this.actId};
                //异步请求
                this.$http.post(this.admin_host+"/admin/activity/modify/status",params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                if (status == 0) {
                                    this.$message({showClose: true, message: '暂停成功', type: 'success'});
                                }else if (status == 1) {
                                    this.$message({showClose: true, message: '开启成功', type: 'success'});
                                }
                            }else if (response.body.Code == "400") {
                                console.log("400")
                                this.$message({
                                    showClose: true,
                                    message: '参数错误',
                                    type: 'error'
                                });
                            }else if (response.body.Code == "500") {
                                console.log("500")
                                this.$message({
                                    showClose: true,
                                    message: '网络异常',
                                    type: 'error'
                                });
                            }
                        }
                    },function(response){
                        console.log("fail")
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })

            },

           // radio 事件 触发生成商品str
            getGoodsStr:function(){
                //所有商品参加
                if(this.appInfo.goods_type==0){
                    this.is_show_portion_product_list=false;
                    this.appInfo.sku_str="";


                    //已选择的售货机，所有商品参加
                    var tenantId=this.getcookie('storeId');

                    var str="";
                    for(var i=0;i<this.kioskNoList.length;i++){
                       ;
                        var machine_id=this.kioskNoList[i].machine_id;
                        //查询商品
                        var params = { active:0 ,len: 100,kioskNo:machine_id, tenantId: tenantId, productName:"" };

                        this.getPutaWay(params,this);
                    }


                }
                if(this.appInfo.goods_type==1){
                    //删除已经选择的商品
                    this.appInfo.sku_str="";
                    //
                    this.readGoodslist=[];
                    this.pagesCount=0;
                    //如果类型为部分则显示部分商品列表
                    this.is_show_portion_product_list=true;


                   // this.findFullSubractList();
                }

            },
            showProduct:function () {
                this.isShowProduct=true;
                this.dialogVisible=true;
            },
            closeProduct:function(){
                this.isShowProduct=false;
                this.dialogVisible=false;

            },
            //商品插件回调已选择的商品
            handleSelectionChange:function(payload){
                var sku_str="";

                if(payload!=null){
                    $.each(payload,function (i,item) {
                                var sku= item.SKU;
                                var machine_id=item.kioskNo;
                                var str=machine_id+"="+sku;
                                     sku_str+=str+",";
                    });
                    this.appInfo.sku_str+=sku_str;
                  //  console.log("部分商品参加==>"+this.appInfo.sku_str);
                    //执行保存操作
                  this.saveAjax();
                    //this.findFullSubractList();
                }
            },
            //批量选择商品
            batchGetGoods:function(idarray){
                if(idarray.length>0){
                    this.batchdisable=false;
                }else{
                    this.batchdisable=true;
                }
                var ids="";
                $.each(idarray,function (i,item) {
                    ids+= item.id+",";
                })
              this.appInfo.ids=ids;
            },
            //批量删除商品
            batchRemoveGoods:function () {
                if(this.appInfo.ids!=""){
                    this.removeGoods(this.appInfo.ids);
                }
            },
            /*卡片跳转*/
            sendMsgToParent: function (step, id) {
                this.$emit("listenToChildEventDef", step, id)
            },
            nextStep() {
                this.sendMsgToParent("5", this.actId)
            },
            lastStep() {
                this.sendMsgToParent("3", this.actId)
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// FullSubtractApp.vue?24d9da55